<template>
  <div class="dm-searchform">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        :placeholder="placeholder"
        v-model="localSearchTerm"
        v-on:keyup.enter="search(localSearchTerm)"
      />
      <div class="input-group-append">
        <slot
          name="searchButton"
          :search="search"
          :localSearchTerm="localSearchTerm"
        >
          <button
            class="btn btn-primary"
            type="button"
            id="searchform"
            @click="search(localSearchTerm)"
          >
            <i class="far fa-search"></i>
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import DealerModuleProvider from '../providers/DealerModuleProvider.js';
import HaversineGeolocation from '../modules/haversine/haversine.js';

export default {
  name: 'SearchFormLocation',
  data() {
    return {
      dealers: [],
      localSearchTerm: '',
      placeholder: '',
      isGeolocation: false,
      currentPoint: {},
      errorMessage: '',
      loading: false
    };
  },
  props: {
    foundDealers: Array,
    apiUrl: String,
    apiKey: String,
    numberOfResults: String,
    culture: String,
    selectedCategories: Array,
    mapOptions: Object,
    homePosition: Object,
    translations: Object
  },
  methods: {
    getCountryFromCulture(culture) {
      const parts = culture.split('-');
      return parts.length > 1 ? parts[1].toUpperCase() : null;
    },
    search(searchTerm) {
      var term = searchTerm;

      var provider = new DealerModuleProvider({
        apiUrl: this.apiUrl,
        culture: this.culture,
        numberOfResults: this.numberOfResults
      });

      var t = this;

      if (term !== '') {
        if (typeof term === 'string') {
          var geocoder = new this.google.maps.Geocoder();
          const region = this.getCountryFromCulture(this.culture);

          geocoder.geocode(
            { address: searchTerm, region },
            function (results, status) {
              let location = {
                lat: -999,
                lng: 999
              };
              if (status == 'OK') {
                location.lat = results[0].geometry.location.lat();
                location.lng = results[0].geometry.location.lng();
              } else if (t.currentPoint.lat && t.currentPoint.lng) {
                location.lat = t.currentPoint.lat;
                location.lng = t.currentPoint.lng;
              }

              provider
                .search(location, t.selectedCategories, null, searchTerm)
                .then((response) => {
                  var parsedResults = JSON.parse(response);
                  var results = parsedResults.value;
                  t.dealers = results;
                  t.$emit('update:foundDealers', t.dealers);
                  t.$emit('update:homePosition', location);
                })
                .catch((error) => {
                  this.errorMessage = 'Unable to load dealers ' + error;
                  this.loading = false;
                  return;
                });
            }
          );

          if (term !== this.$route.query.searchTerm) {
            this.$router.replace({
              name: '',
              query: { ...this.$route.query, searchTerm: term }
            });
          }
        } else {
          provider
            .search(term, t.selectedCategories)
            .then((response) => {
              var parsedResults = JSON.parse(response);
              var results = parsedResults.value;
              t.dealers = results;
              t.$emit('update:foundDealers', t.dealers);
              t.$emit('update:homePosition', term);
            })
            .catch((error) => {
              this.errorMessage = 'Unable to load dealers ' + error;
              this.loading = false;
              return;
            });
        }
      } else {
        if (term !== this.$route.query.searchTerm) {
          this.$router.replace({
            name: '',
            query: { ...this.$route.query, searchTerm: term }
          });
        }
        HaversineGeolocation.isGeolocationAvailable()
          .then((data) => {
            this.currentPoint = {
              lat: data.coords.latitude,
              lng: data.coords.longitude,
              accuracy: data.coords.accuracy
            };
            this.search(this.currentPoint);
          })
          .catch(() => {
            t.$emit('update:foundDealers', []);
            t.$emit('update:homePosition', {});
          });
      }
    }
  },
  computed: {
    google: gmapApi
  },
  watch: {
    google() {
      if (this.$route.query.searchTerm) {
        this.placeholder = this.translations.InputPlaceholder;
        this.localSearchTerm = this.$route.query.searchTerm;
        this.search(this.localSearchTerm);
      } else {
        this.placeholder = this.translations.YourCurrentLocation;
        HaversineGeolocation.isGeolocationAvailable().then((data) => {
          this.currentPoint = {
            lat: data.coords.latitude,
            lng: data.coords.longitude,
            accuracy: data.coords.accuracy
          };
          this.search(this.currentPoint);
        });
      }
    },
    selectedCategories() {
      if (this.currentPoint.lat) {
        this.search(this.currentPoint);
      } else {
        this.search(this.localSearchTerm);
      }
    }
  }
};
</script>

<style lang="scss">
.dm-searchform {
  flex: 0 0 auto;
  padding: 30px;
}
</style>
